/*
The GPU License
Copyright (c) 2021 p-themes
Modified to properly handle Shopify price filter state
*/

function scrollwidgetsInit(){
  var $scrollwidget = $(".scrollwidget");
  if(!$scrollwidget.length) return false;

  $('.aside.leftColumn').addClass('withpricerage');

  $scrollwidget.each(function(){
    scrollwidgetSingleInit($(this));
  })
}

function scrollwidgetSingleInit($scrollwidget){

  var $minf = $scrollwidget.find('input').first(),
      $maxf = $scrollwidget.find('input').last(),
      $scrollline = $scrollwidget.find('.scrollwidget_scroll_line'),
      $scrolllineactive = $scrollwidget.find('.scrollwidget_scroll_active'),
      $minb = $scrollwidget.find('.scrollwidget_scroll_btn__left'),
      $maxb = $scrollwidget.find('.scrollwidget_scroll_btn__right'),
      minv = Number($scrollwidget.attr('data-min')),
      maxv = Number($('.currentmaxpriceinwidget').text().replace(',', '').match(/\d+/g)[0]),
      widthb = $minb.outerWidth(),
      inputtimer = false,
      mainmaxval = Number($scrollwidget.attr('data-max')),
      scale = mainmaxval/maxv;

  /* --------------------------
     READ ACTIVE SHOPIFY FILTER
  -------------------------- */

  function applyUrlValues(){
    const params = new URLSearchParams(window.location.search);
    const urlMin = params.get('filter.v.price.gte');
    const urlMax = params.get('filter.v.price.lte');

    if(urlMin !== null){
      $minf.val(urlMin);
      setInputDataValue($minf, urlMin*scale);
    } else {
      $minf.val(minv);
      setInputDataValue($minf, minv);
    }

    if(urlMax !== null){
      $maxf.val(urlMax);
      setInputDataValue($maxf, urlMax*scale);
    } else {
      $maxf.val(maxv);
      setInputDataValue($maxf, mainmaxval);
    }
  }

  function setInputDataValue($this,val){
    $this.attr('data-value', Math.round(val));
  }

  /* --------------------------
     INPUT EVENTS
  -------------------------- */

  $minf.on('input change keypress change.start', function(e){
    if(e.type == 'keypress') return !(event.charCode == 46 || event.charCode == 69 || event.charCode == 101);

    if("namespace" in e){
      $(this).val(Math.round($(this).attr('data-value')/scale));
    }

    var val = Number($(this).val());

    if($scrollline.length){
      var scrollwidth = $scrollline.width()-widthb*2,
          maxvalcalc = scrollwidth/(maxv-minv),
          pos = Math.min(Math.round(maxvalcalc*(val-minv)), $maxb.position().left-widthb),
          pos = Math.max(0, pos);
    }

    if(!("namespace" in e)){
      setInputDataValue($(this), val*scale);
    }

    if(Number($(this).attr('data-value')) > Number($maxf.attr('data-value'))){
      $(this).val($maxf.val());
      setInputDataValue($(this), $(this).val()*scale);
    }

    if(!$(this).is(':focus')) val < minv && $(this).val(minv);

    $minb.length && $minb.css('left', pos);
    setScrolllineactiveWidth();

    if(!("namespace" in e) && e.type != 'change'){
      clearTimeout(inputtimer);
      inputtimer = setTimeout(function(){
        $(window).trigger('pricechangestate', [$scrollwidget])
      }, 600);
    }

    $(this).val() == 0 && $(this).val('');
  });

  $maxf.on('input change keypress change.start', function(e){
    if(e.type == 'keypress') return !(event.charCode == 46 || event.charCode == 69 || event.charCode == 101);

    if("namespace" in e){
      $(this).val(Math.round($(this).attr('data-value')/scale));
    }

    var val = Number($(this).val());

    if($scrollline.length){
      var scrollwidth = $scrollline.width()-widthb*2,
          maxvalcalc = scrollwidth/(maxv-minv),
          pos = Math.min(Math.round(maxvalcalc*(val-minv)+widthb), $scrollline.width()-widthb),
          pos = Math.max($minb.position().left+widthb, pos);
    }

    if(!("namespace" in e)){
      setInputDataValue($(this), val*scale);
    }

    val > maxv && $(this).val(maxv);
    if(!$(this).is(':focus')) val < $minf.val() && $(this).val($minf.val());

    $maxb.length && $maxb.css('left', pos);
    setScrolllineactiveWidth();

    if(!("namespace" in e) && e.type != 'change'){
      clearTimeout(inputtimer);
      inputtimer = setTimeout(function(){
        $(window).trigger('pricechangestate', [$scrollwidget])
      }, 600);
    }
  });

  /* --------------------------
     DRAG EVENTS (ORIGINAL)
  -------------------------- */

  $minb.on('mousedown touchstart', function(e){	
    e.preventDefault();
    var $this = $(this),
        mousedelta = $this.offset().left - (e.type == 'touchstart' ? e.originalEvent.targetTouches[0].clientX : e.clientX),
        widgetpos = $scrollline.offset().left,
        scrollwidth = $scrollline.width()-widthb*2,
        datawidth = $maxb.position().left-widthb;

    $(window).on('mousemove.scrolldrag touchmove.scrolldrag', function(e){
      var mousemove = e.type == 'touchmove' ? e.originalEvent.targetTouches[0].clientX : e.clientX,
          pos = Math.max(0, mousemove-widgetpos+mousedelta),
          pos = Math.min(pos, datawidth),
          maxvalcalc = (maxv-minv)/scrollwidth,
          fmaxval = Number($maxf.val()),
          val = Math.round(maxvalcalc*pos)+minv;

      val = val > fmaxval ? fmaxval : val;

      $this.css('left', pos);
      $minf.val(val);
      setInputDataValue($minf, val*scale);
      setScrolllineactiveWidth();
    });

    $(window).on('mouseup.scrolldrag touchend.scrolldrag', function(){
      $(window).unbind('mousemove.scrolldrag touchmove.scrolldrag');
      $(window).unbind('mouseup.scrolldrag touchend.scrolldrag');
      $(window).trigger('pricechangestate', [$scrollwidget]);
    });
  });

  $maxb.on('mousedown touchstart', function(e){
    e.preventDefault();
    var $this = $(this),
        mousedelta = $this.offset().left - (e.type == 'touchstart' ? e.originalEvent.targetTouches[0].clientX : e.clientX),
        widgetpos = $scrollline.offset().left,
        scrollwidth = $scrollline.width()-widthb*2,
        datawidth = $minb.position().left + widthb;

    $(window).on('mousemove.scrolldrag touchmove.scrolldrag', function(e){
      var mousemove = e.type == 'touchmove' ? e.originalEvent.targetTouches[0].clientX : e.clientX,
          pos = Math.max(datawidth, mousemove-widgetpos+mousedelta),
          pos = Math.min(pos, $scrollline.width()-widthb),
          maxvalcalc = (maxv-minv)/scrollwidth,
          fmaxval = Number($minf.val()),
          val = Math.round(maxvalcalc*(pos-widthb))+minv;

      val = val < fmaxval ? fmaxval : val;

      $this.css('left', pos);
      $maxf.val(val);
      setInputDataValue($maxf, val*scale);
      setScrolllineactiveWidth();
    });

    $(window).on('mouseup.scrolldrag touchend.scrolldrag', function(){
      $(window).unbind('mousemove.scrolldrag touchmove.scrolldrag');
      $(window).unbind('mouseup.scrolldrag touchend.scrolldrag');
      $(window).trigger('pricechangestate', [$scrollwidget]);
    });
  });

  /* --------------------------
     RESET LOGIC FIXED
  -------------------------- */

  $(window).on('resetscrollwidget', function(){
    applyUrlValues();
    $minf.trigger('change.start');
    $maxf.trigger('change.start');
  });

  function setScrolllineactiveWidth(){
    if(!$scrolllineactive.length) return false;
    $scrolllineactive.css({
      left: $minb.position().left+$minb.width()-3,
      right: $scrollline.width()-$maxb.position().left-3
    });
  }

  function updateWidget(){
    applyUrlValues();
    $minf.trigger('change.start');
    $maxf.trigger('change.start');
  }

  updateWidget();
  $(window).resize(updateWidget);
}

scrollwidgetsInit();